import React from 'react';
import {Field, Form} from 'react-final-form'
import {Input, NumberInput} from './../../../components/ui';
import {FinalButtonSet} from "../../../components/ui/form";

type ManufacturerFormProps = { initialValues, onSubmit }
const ExpenseTypeForm = ({initialValues = {}, onSubmit}: ManufacturerFormProps) => {
    return (
        <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
        >
            {({handleSubmit, pristine, submitting}) => (
                <form onSubmit={handleSubmit}>
                    <Field
                        name='label'
                        label='Name'
                        component={Input}
                    />
                    <Field
                        name='rate'
                        label='Rate'
                        component={NumberInput}
                    />
                    <FinalButtonSet submitting={submitting} pristine={pristine} mode={"RELATIVE"}/>
                </form>
            )}
        </Form>
    )
}


export default ExpenseTypeForm;
